import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Etiqueta from 'components/etiquetas/Etiqueta'
import Navbar from 'components/generales/Navbar'
import Boton from 'components/boton/Boton'
import Filtros from 'components/etiquetas/Filtros'
import axios from "axios"

import 'components/generales/Styles.css'

const ListadoEtiquetas = () => {

  const [etiquetas, setEtiquetas] = useState([])
  const navigate = useNavigate()

  // FILTROS
  const [etiquetasFiltered, setEtiquetasFiltered] = useState([])
  const [filtroTipo, setFiltroTipo] = useState('')
  const [filtroClasificacion, setFiltroClasificacion] = useState('')
  const [filtroColor, setFiltroColor] = useState('')

  useEffect(() => {
    const obtenerEtiquetasApi = async () => {
      try {
        const { data } = await axios.get('https://mymoney5.herokuapp.com/etiquetas/')
        setEtiquetas(data)
        setEtiquetasFiltered(data)
      } catch (error) {
        console.log(error);
      }
    }
    obtenerEtiquetasApi()
  }, [])

  const handleEliminar = async id => {
    const confirmar = window.confirm('¿Deseas eliminar esta etiqueta?')
    if (confirmar) {
      try {
        await axios.patch(`https://mymoney5.herokuapp.com/etiquetas/${id}`)
        const arrayEtiquetas = etiquetas.filter(etiqueta => etiqueta.id !== id)
        const arrayEtiquetasFiltered = etiquetasFiltered.filter(etiqueta => etiqueta.id !== id)
        setEtiquetas(arrayEtiquetas)
        setEtiquetasFiltered(arrayEtiquetasFiltered)
      } catch (error) {
        console.log(error)
      }
    }
  }
  // FILTROS
  const filterEtiquetas = () => {
    const filterByType = etiquetas.filter(etiqueta => {
      if (filtroTipo === "") return etiqueta
      if (etiqueta.tipo === filtroTipo) return etiqueta
    })
    //console.log(filterByType)
    const filterByClasification = filterByType.filter(etiqueta => {
      if (filtroClasificacion === "") return etiqueta
      if (etiqueta.clasificacion === filtroClasificacion) return etiqueta
    })
    const filterByColor = filterByClasification.filter(etiqueta => {
      if (filtroColor === "") return etiqueta
      if (etiqueta.color === filtroColor) return etiqueta
    })
    setEtiquetasFiltered(filterByColor)
  }

  useEffect(() => {
    filterEtiquetas()
    //console.log({ filtroTipo, filtroClasificacion, filtroColor })
  }, [filtroTipo, filtroClasificacion, filtroColor])

  return (
    <>
      <Navbar />
      <div className="lista-preview">
        <h2>Listado de Etiquetas</h2>
        <p>Etiquetas Registradas</p>

        <div className='filtros'>
          <Filtros
            filtroTipo={filtroTipo}
            setFiltroTipo={setFiltroTipo}
            filtroClasificacion={filtroClasificacion}
            setFiltroClasificacion={setFiltroClasificacion}
            filtroColor={filtroColor}
            setFiltroColor={setFiltroColor}
          />
        </div>

        <div className='listado'>
          {etiquetasFiltered.map(etiqueta => (
            <Etiqueta
              key={etiqueta.id}
              etiqueta={etiqueta}
              handleEliminar={handleEliminar}
              filtroTipo={filtroTipo}
              filtroClasificacion={filtroClasificacion}
              filtroColor={filtroColor}
            />
          ))}
        </div>

        <Boton
          type="button"
          buttonStyle="botonTransparente"
          onClick={() => navigate(`/etiquetas/nueva`)}
        >Registrar etiqueta nueva</Boton>
      </div>
    </>
  );
};

export default ListadoEtiquetas;
